import React from 'react';
import Footer from 'components/footer';
import Header from 'components/login-header';
import ImportRecords from 'components/import-records';
import 'pages/styles/admin-login-page.css';

const AdminPage = () => {
  return (
    <>
      <Header />
      <ImportRecords />
      <Footer />
    </>
  );
};
export default AdminPage;
